"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpHeader = void 0;
const tmpls_1 = require("./tmpls");
const AppVX_1 = require("../AppVX");
const ClassesTags_1 = require("../ClassesTags");
class CmpHeader extends tmpls_1.CmpHeaderBase {
    constructor() {
        super();
        this._connectText = "";
        this.ctrls.btnMenu.onclick = () => this.ctrls.blockMobileNav.flipClass(ClassesTags_1.ClassesTags.Active);
        this.ctrls.btnConnect.disable();
        this._connectText = this.ctrls.btnConnect.text;
        this.ctrls.btnConnect.onclick = () => __awaiter(this, void 0, void 0, function* () {
            this.ctrls.btnConnect.disable();
            const result = yield AppVX_1.AppVX.Inst.chain.tryConnectAsync();
            this.ctrls.btnConnect.enable();
        });
    }
    initAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            AppVX_1.AppVX.Inst.chain.onChangeAccount.addHandler(() => __awaiter(this, void 0, void 0, function* () {
                yield this.refreshConnectionAsync();
            }));
            yield this.refreshConnectionAsync();
        });
    }
    refreshConnectionAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (AppVX_1.AppVX.Inst.chain.account) {
                const wallet = AppVX_1.AppVX.Inst.chain.account;
                this.ctrls.btnConnect.disable();
                this.ctrls.btnConnect.text = wallet.slice(0, 6) + "..." + wallet.slice(-4);
                // this.ctrls.
                //    this.ctrls.
            }
            else {
                this.ctrls.btnConnect.enable();
                this.ctrls.btnConnect.text = this._connectText;
            }
            const chainId = yield AppVX_1.AppVX.Inst.chain.getChainIdAsync();
            if (chainId == AppVX_1.AppVX.CHAIN_ID) {
                this.ctrls.tagPLS.show();
                this.ctrls.tagWrongChain.hide();
            }
            else {
                this.ctrls.tagPLS.hide();
                this.ctrls.tagWrongChain.show();
            }
        });
    }
}
exports.CmpHeader = CmpHeader;
//# sourceMappingURL=CmpHeader.js.map